"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TicketStatus = _interopRequireDefault(require("../TicketStatus"));
var _Select = _interopRequireDefault(require("../../../Select"));
var _constants = require("../../../../constants");
var _constants2 = require("../TicketStatus/constants");
var _excluded = ["value", "priority", "type", "time", "closeReason", "planReason", "onClickStatus", "orderIds", "onChange"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var STATUSES = _TicketStatus["default"].STATUSES,
  PRIORITIES_BY_STATUS = _TicketStatus["default"].PRIORITIES_BY_STATUS;
var StyledSelected = _Select["default"].StyledSelected;
var TicketStatusSelector = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var value = _ref.value,
    ticketPriority = _ref.priority,
    type = _ref.type,
    time = _ref.time,
    closeReason = _ref.closeReason,
    planReason = _ref.planReason,
    onClickStatus = _ref.onClickStatus,
    orderIds = _ref.orderIds,
    onChange = _ref.onChange,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var statuses = (0, _toConsumableArray2["default"])(Object.values(STATUSES));
  var initialValue = statuses.includes(value) ? value : STATUSES.OPEN;
  var options = (0, _react.useMemo)(function () {
    return statuses.map(function (optionValue) {
      return {
        value: optionValue,
        title: optionValue,
        priority: PRIORITIES_BY_STATUS[optionValue]
      };
    });
  }, [STATUSES]);
  var headRenderer = function headRenderer(_ref2) {
    var title = _ref2.title,
      priority = _ref2.priority;
    return /*#__PURE__*/_react["default"].createElement(_TicketStatus["default"], {
      title: title,
      priority: priority,
      time: time,
      planReason: planReason,
      type: type,
      closeReason: closeReason,
      orderIds: orderIds,
      placement: _constants2.TICKET_STATUS_PLACEMENT.TICKET_STATUS_SELECTOR
    });
  };
  var optionRenderer = function optionRenderer(_ref3) {
    var optionValue = _ref3.value,
      title = _ref3.title,
      priority = _ref3.priority;
    return /*#__PURE__*/_react["default"].createElement(_TicketStatus["default"], {
      title: title,
      onClick: function onClick() {
        return onClickStatus(optionValue);
      },
      priority: priority,
      isOption: true,
      placement: _constants2.TICKET_STATUS_PLACEMENT.TICKET_STATUS_SELECTOR
    });
  };
  return /*#__PURE__*/_react["default"].createElement(StyledStatusContainer, null, /*#__PURE__*/_react["default"].createElement(StyledTicketStatusSelector, (0, _extends2["default"])({}, props, {
    onChange: onChange,
    value: initialValue,
    options: options,
    headRenderer: headRenderer,
    optionRenderer: optionRenderer
  })));
});
TicketStatusSelector.displayName = 'TicketStatusSelector';
TicketStatusSelector.propTypes = {
  className: _propTypes["default"].string,
  value: _propTypes["default"].string,
  time: _propTypes["default"].number,
  orderIds: _propTypes["default"].arrayOf(_propTypes["default"].string),
  closeReason: _propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].string
  }),
  planReason: _propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].string
  }),
  type: _propTypes["default"].oneOf(Object.values(_constants.TICKET_TYPES))
};
TicketStatusSelector.defaultProps = {
  className: '',
  value: null,
  time: null,
  orderIds: null,
  closeReason: null,
  planReason: null,
  type: _constants.TICKET_TYPES.UNKNOWN
};
var StyledStatusContainer = _styledComponents["default"].div.withConfig({
  displayName: "TicketStatusSelector__StyledStatusContainer",
  componentId: "sc-1t46cai-0"
})(["width:auto;"]);
var StyledTicketStatusSelector = (0, _styledComponents["default"])(_Select["default"]).withConfig({
  displayName: "TicketStatusSelector__StyledTicketStatusSelector",
  componentId: "sc-1t46cai-1"
})(["height:30px;border:none;width:200px;line-height:30px;background:transparent;*{outline:none;}", "{padding:0;}"], StyledSelected);
var _default = exports["default"] = TicketStatusSelector;